import { useAsyncExecutor } from "async-executor-hook";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { BodyContainerTableCommon } from "../../../common/components/TableResponsive";
import {
  onlyLetterNumberCharacterGuion,
  WInputText,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { getErrorValueResponse } from "../../../common/error/Error";
import { removeNullProps } from "../../../common/utils";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { ContainerInputs, ContainerTitleSync } from "../SyncronizeDataStyled";

interface ICreateAirWaybillExecutorParams {
  to_date: string;
  from_date: string;
  house_air_waybill: string;
  succeed?: any;
  failed?: any;
}

export const SyncronizeHouseAirWaybill = () => {
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        house_air_waybill: new FormControl(),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form, { processing, succeed, failed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      processing();
      createUserExecutor.execute({
        ...form.value,
        succeed,
        failed,
      });
    },
  });
  const createUserExecutor = useAsyncExecutor(
    (params: ICreateAirWaybillExecutorParams) => {
      const { house_air_waybill } = params;
      const urlPostHouseAir = `/sync-engine/manual-synchronization/${house_air_waybill}/house-air-waybill/`;
      return networkBackendRequest(
        urlPostHouseAir,
        HTTP_METHODS.POST,
        removeNullProps({ house_air_waybill })
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (_, params: ICreateAirWaybillExecutorParams) => {
        params.succeed();
        formConfig.loadSucceed({});
        toast.current.show({
          severity: "success",
          summary: "Operación exitosa",
          detail: `La sincronización de ${params.house_air_waybill} se realizó con éxito.`,
          life: 5000,
        });
      },
      onError(error, params: ICreateAirWaybillExecutorParams) {
        const errorMessage = getErrorValueResponse(error);
        params.failed();
        toast.current.show({
          severity: "error",
          summary: "Atención",
          detail: errorMessage,
          life: 3000,
        });
      },
    }
  );

  useEffect(() => {
    formConfig.loadSucceed({});
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Toast ref={toast}></Toast>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <BodyContainerTableCommon className="item-container" height="10rem">
          <div
            className="attribute"
            style={{
              display: "flex",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <div className="titles">{"Sincronizar"}</div>
            <ContainerTitleSync>
              <div style={{ fontSize: "1.6rem", color: "#2E353D" }}>
                Por Guía Hija
              </div>
              <div style={{ fontSize: "1.2rem", color: "#989CA2" }}>
                <p style={{ maxWidth: "27rem" }}>
                  Sincronice la información de la carga en base al{" "}
                  <strong>número de guía hija.</strong>
                </p>
              </div>
            </ContainerTitleSync>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"PARÁMETROS DE SINCRONIZACIÓN"}</div>
            <div className="left-align" style={{ width: "100%" }}>
              <ContainerInputs>
                <div>
                  <WFormControl name="house_air_waybill">
                    <TemplateInputContainer
                      label="N° Guía Hija"
                      color="#002E6C"
                    >
                      <WInputText
                        width="20rem"
                        height="4rem"
                        fontSize="1.4rem"
                        placeholder="Número de Guía Hija"
                        onKeyPress={onlyLetterNumberCharacterGuion}
                      />
                    </TemplateInputContainer>
                  </WFormControl>
                </div>
                <div></div>
              </ContainerInputs>
            </div>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"ACCIONES"}</div>
            <div className="left-align">
              <SaveButton
                label="Sincronizar"
                width="17rem"
                height="3.8rem"
                fontSize="1.5rem"
                backgroundColor="#002E6C"
                isDisabled={formConfig?.form?.value.house_air_waybill < 1}
              />
            </div>
          </div>
        </BodyContainerTableCommon>
      </WForm>
    </div>
  );
};
